<template>
	<div class="risk-meter circular-element">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.16 78.16" class="risk-meter risk-level-5" :class="[`risk-level-${level}`]" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><radialGradient id="bolt-gradient" gradientUnits="userSpaceOnUse" cx="39.08" cy="39.08" r="39.08"><stop offset=".19" stop-color="#df9031"/><stop offset=".54" stop-color="#ffde6d"/><stop offset=".65" stop-color="#ffedb6"/><stop offset=".7" stop-color="#f5cf61"/></radialGradient><radialGradient id="inner-gradient" cx="39.08" cy="39.08" gradientUnits="userSpaceOnUse" r="38"><stop offset="0" stop-color="#822818"/><stop offset=".79" stop-color="#191007"/></radialGradient><linearGradient id="ring-gradient" gradientUnits="userSpaceOnUse" x2="78.16" y1="39.08" y2="39.08"><stop offset=".17" stop-color="#e9ad47"/><stop offset=".3" stop-color="#ffde6d"/><stop offset=".46" stop-color="#df9031"/><stop offset="1" stop-color="#b1570d"/></linearGradient></defs><circle cx="39.08" cy="39.08" fill="url(#inner-gradient)" r="38" stroke="url(#ring-gradient)" stroke-miterlimit="10" stroke-width="2.16"/><g fill="#ffedb6"><path d="M33.42 54.57h-2.87l-1.3-3.49-.07-.23c0-.1-.07-.22-.12-.35v4.07h-2.61v-9.8h2.71a4.29 4.29 0 012.68.71A3.09 3.09 0 0133 48a2.47 2.47 0 01-1.52 2.46zm-4.33-5.26h.18A1 1 0 0030 49a1.27 1.27 0 00.31-.89c0-.73-.39-1.1-1.15-1.1h-.1zM37.59 54.57h-2.65v-9.8h2.65zM39.4 54.33v-3.08a2.17 2.17 0 001.69 1.07.84.84 0 00.56-.18.58.58 0 00.22-.46 1 1 0 00-.47-.76l-.4-.34a6.94 6.94 0 01-.73-.64 4.1 4.1 0 01-.5-.66 3.27 3.27 0 01-.28-.71 3.11 3.11 0 01-.08-.76 3.66 3.66 0 01.31-1.43 3.58 3.58 0 01.37-.64 2.9 2.9 0 01.48-.51 2.69 2.69 0 011.81-.64 4.16 4.16 0 011.91.5v3a2.82 2.82 0 00-.74-.79 1.43 1.43 0 00-.85-.3.71.71 0 00-.5.18.51.51 0 00-.21.41 1 1 0 00.54.78l.42.31a4.2 4.2 0 011.2 1.24 2.89 2.89 0 01.37 1.49 3.36 3.36 0 01-.88 2.39 3 3 0 01-2.24.93 5.46 5.46 0 01-2-.4zM53.4 54.57h-2.86l-1.76-4.52.07 4.52h-2.64v-9.8h2.64L48.78 49l1.56-4.2h2.8L51 49.5zM28.35 66.88h-4.63v-9.81h2.65v7.45h2zM29.79 66.88v-9.81h4.92v2.31h-2.27v1.43h2V63h-2v1.5h2.27v2.36zM40.75 66.88h-2.69l-2.25-9.81h2.78l.48 2.8c.18 1.07.33 2.27.44 3.6.05-.59.1-1.14.17-1.65s.15-1 .24-1.5l.63-3.25h2.88zM44.76 66.88v-9.81h4.92v2.31h-2.27v1.43h2V63h-2v1.5h2.27v2.36zM56.1 66.88h-4.64v-9.81h2.65v7.45h2z"/></g><path class="bolt bolt-1" d="M6.08 33.08v9l14 3v-6l13 3-18-11v6z"/><path class="bolt bolt-2" d="M12.08 19.08l6-7 4 9 4-4 9 21-10-12-4 5z"/><path class="bolt bolt-3" d="M34.08 7.08h8l-2 9 5-2-6 22v-13l-4 2z"/><path class="bolt bolt-4" d="M66.08 19.08l-6-7-4 9-4-4-9 21 10-12 4 5z"/><path class="bolt bolt-5" d="M72.08 33.08v9l-14 3v-6l-13 3 18-11v6z"/></svg>
	</div>
</template>

<script>
export default {
	name: 'RiskMeterSVG',
	props: {
		level: {
			type: Number,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.risk-meter {
		::v-deep .bolt { fill: #793619; }
	}

	.risk-level-1 {
		::v-deep .bolt-1 { fill: url('#bolt-gradient'); }
	}

	.risk-level-2 {
		::v-deep .bolt-1 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-2 { fill: url('#bolt-gradient'); }
	}

	.risk-level-3 {
		::v-deep .bolt-1 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-2 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-3 { fill: url('#bolt-gradient'); }
	}

	.risk-level-4 {
		::v-deep .bolt-1 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-2 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-3 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-4 { fill: url('#bolt-gradient'); }
	}

	.risk-level-5 {
		::v-deep .bolt-1 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-2 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-3 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-4 { fill: url('#bolt-gradient'); }
		::v-deep .bolt-5 { fill: url('#bolt-gradient'); }
	}
</style>
